import { useMutation, useQueryClient } from '@tanstack/react-query';
import { ConsentsService } from '../services';
import { factoryGetOfficeConsentContentKey } from '../factories/queries/factoryGetOfficeConsentContentKey';
import type { IAcceptOfficeConsentContentParameters } from '../types/OfficeConsentContent.parameters';
import { showErrorMessage } from '~/domain/utils';

interface IUseAcceptOfficeConsentContent {
  onError?: () => void;
  onSuccess?: () => void;
}

export const useAcceptOfficeConsentContent = ({
  onError,
  onSuccess,
}: IUseAcceptOfficeConsentContent) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (params: IAcceptOfficeConsentContentParameters) =>
      ConsentsService.acceptOfficeConsentContent(params),
    onSuccess(_data, variables) {
      queryClient.invalidateQueries({
        queryKey: factoryGetOfficeConsentContentKey(variables),
      });

      onSuccess?.();
    },
    onError(error) {
      onError?.();
      showErrorMessage({ error });
    },
  });
};
